<template>
  <div id="app">
    <v-uploader :postURL="getUploadURL()" v-on:uploadComplete="uploadComplete" v-on:uploadFail="uploadFail" :isStartUpload="$store.state.startUpload" ></v-uploader>
    <v-preview :isStartPreview="$store.state.startPreview"  v-on:close="close()" :datas="$store.state.fileInfo.currentFile"></v-preview>
    <v-menu-list></v-menu-list>
    <v-action-list></v-action-list>
    <v-sort-list></v-sort-list>
    <v-dialog></v-dialog>
    <router-view></router-view>
    <v-add-folder ></v-add-folder>
    <v-toast></v-toast>
  </div>

</template>

<script>
import uploader from './components/uploader/uploader.vue'
import preview from './components/preview/preview.vue'
import toast from './components/toast/toast.vue'
import dialog from './components/filelist/filelist_rename.vue'
import menulist from './components/menu/menu_current_file.vue'
import currentFileMenu from './components/menu/menu_current_folder.vue'
import sortlist from './components/menu/menu_sort.vue'
import addFolder from './components/filelist/filelist_add_folder.vue'
import store from './store'
import * as Util from 'util'
import * as UserManager from './SDK/UserManager'

export default {
  data () {
    return {
      info: { }
    }
  },
  methods: {
    uploadComplete (total) {
      console.log('app upload complete ....')
      let params = {
        isShow: true,
        message: this.translate(this.$language, 'upload_complete_text', [total]),
        iconClass: 'icon-success', // iconClass根据实际情况传相对应的值
        autoClose: false
      }
      store.commit('setToast', params)
      store.commit(`setStartUpload`, false)
      store.commit(`setIsReloadFilelist`, true)
      document.getElementById('lenovobox_upload_btn').value = ''
    },
    uploadFail (message) {
      let params = {
        isShow: true,
        message: message,
        iconClass: 'icon-error'// iconClass根据实际情况传相对应的值
      }
      store.commit('setToast', params)
      document.getElementById('lenovobox_upload_btn').value = ''
    },
    getUploadURL () {
      let currentPath = store.getters.getFullPath
      let sessionID = ``
      let UID = ``
      let s = ''
      if (store.state.userInfo) {
        UID = store.state.userInfo['user_id']
      }
      let pathType = store.getters.getCurrentPathType
      let prefix = ''
      if (store.getters.getCurrentFolderInfo.prefix_neid) {
        prefix += 'prefix_neid=' + store.getters.getCurrentFolderInfo.prefix_neid + '&'
      }
      if (store.getters.getCurrentFolderInfo.from) {
        prefix += 'from=' + store.getters.getCurrentFolderInfo.from
      }

      if (Util.getCookie('S')) {
        s = 'S=' + Util.getCookie('S')
      }
      if (Util.getCookie('X-LENOVO-SESS-ID')) {
        sessionID = Util.getCookie('X-LENOVO-SESS-ID')
      }
      return `/v2/files/databox` + currentPath + `/{0}?X-LENOVO-SESS-ID=` + sessionID + `&uid=` + UID + `&overwrite=true&source=file&t=&path_type=` + pathType + '&' + prefix + '&' + s
    },
    close () {
      store.commit('setStartPreview', false)
    }
  },
  watch: {
  },
  components: {
    'v-action-list': currentFileMenu,
    'v-menu-list': menulist,
    'v-sort-list': sortlist,
    'v-uploader': uploader,
    'v-preview': preview,
    'v-dialog': dialog,
    'v-add-folder': addFolder,
    'v-toast': toast
  },
  created () {
    // 判断是否开启了水印
    let params = {
      config_type: 0,
      config_id: 0,
      name: 'watermark_enable'
    }
    UserManager.configGet(params)
      .then(response => {
        console.log(response + 'configGet Success')
        if (response.length > 0 && response[0].value === 'true') {
          store.state.watermarkEnable = true
        } else {
          store.state.watermarkEnable = false
        }
      }, error => {
        console.log(error + 'configSet Error')
      })
  },
  computed: {}
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../static/font-icon/style.css"
  @import "./common/stylus/border-1px/index.styl"
  @import "./common/stylus/default/menu-tips.styl"
  @import "./common/stylus/default/dialog.styl"
body,html
  margin:0
  padding:0
  box-sizing:border-box
  background:#ffffff
  user-select:none
  -webkit-tap-highlight-color: transparent
#app
  color: #2c3e50
  font: 14px "Helvetica Neue",Helvetica,Arial,"Microsoft Yahei","Hiragino Sans GB","Heiti SC","WenQuanYi Micro Hei",sans-serif
</style>



// WEBPACK FOOTER //
// App.vue?044a9256